import { isRSC, isWeb } from "@tamagui/constants";
import { useContext } from "react";
import { FontLanguageContext } from "../contexts/FontLanguageContext.js";
import { TextAncestorContext } from "../contexts/TextAncestorContext.js";
import { useSplitStyles } from "../helpers/getSplitStyles.js";
import { useMedia } from "./useMedia.js";
import { useTheme } from "./useTheme.js";
function useStyle(base, style, options) {
  const isText = base.staticConfig.isText;
  const hasTextAncestor = !!(isWeb && isText ? useContext(TextAncestorContext) : false);
  const languageContext = isRSC ? null : useContext(FontLanguageContext);
  const theme = useTheme();
  const media = useMedia();
  const out = useSplitStyles(
    style,
    base.staticConfig,
    theme,
    {
      ...options,
      mediaState: media,
      hasTextAncestor,
      resolveVariablesAs: "auto"
    },
    null,
    languageContext || void 0,
    isText ? "span" : "div",
    options == null ? void 0 : options.debug
  );
  return {
    style: Object.keys(out.style).length ? out.style : null,
    classNames: out.classNames
  };
}
export {
  useStyle
};
//# sourceMappingURL=useStyle.js.map
